import { useMap, MAPBOX_KEY } from './chunk-DWUCGXIQ.js';
import { useDefaultLocation, useSearchContext } from './chunk-UUWHMO43.js';
import { useTokens } from '@gemini/core';
import { isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { decode } from '@mapbox/polyline';
import { CommuteMode, FormLocationType } from '@aviv-search/types';
import { useState, useEffect } from 'react';

var getMapView = (formLocation, isIsochroneLoading) => {
  const hasId = Boolean(formLocation?.id);
  if (!formLocation || !hasId) {
    return "none" /* NONE */;
  }
  const hasCommute = !isIsochroneLoading && Boolean(formLocation.commuteMode) && Boolean(formLocation.commuteDuration) && !isEmpty(formLocation.polylines);
  return hasCommute ? "multipolygon" /* MULTIPOLYGON */ : "pin" /* PIN */;
};
var polylinesToMultipolygon = (polylines) => {
  if (isEmpty(polylines))
    return void 0;
  return polylines.map((polyline) => [decode(polyline).map(([lat, lng]) => [lng, lat])]);
};

// src/containers/CommuteModal/hooks/useIsochroneMap.ts
var useIsochroneMap = ({ locationIndex }) => {
  const {
    "color.content.status.information.default": contentColor,
    "color.border.status.information.default": borderColor,
    "color.background.default": defaultColor
  } = useTokens();
  const { watch } = useFormContext();
  const { coordinates: defaultCoordinates } = useDefaultLocation();
  const { isIsochroneLoading } = useSearchContext();
  const location = watch("locations")?.[locationIndex];
  const mapView = getMapView(location, isIsochroneLoading);
  const center = isEmpty(location?.coordinates) ? defaultCoordinates : location.coordinates;
  const multipolygon = polylinesToMultipolygon(location?.polylines ?? []);
  return useMap({
    accessToken: MAPBOX_KEY,
    multipolygon,
    radius: mapView === "pin" /* PIN */ ? 0 : void 0,
    colors: {
      content: contentColor,
      border: borderColor,
      default: defaultColor,
      ...mapView === "multipolygon" /* MULTIPOLYGON */ ? { multipolygon: borderColor } : {}
    },
    center,
    zoom: 9,
    disableZoom: false,
    disablePan: false,
    mapView
  });
};
var defaultTravelTime = 15;
var defaultTravelMode = CommuteMode.CAR;
var useInitialCommuteLocation = ({ locationIndex }) => {
  const { getValues, setValue } = useFormContext();
  const [isInit, setIsInit] = useState(false);
  useEffect(() => {
    const location = getValues("locations")?.[locationIndex];
    if (location?.type === FormLocationType.COMMUTE) {
      setIsInit(true);
      return;
    }
    setValue("locations", [
      {
        coordinates: location?.coordinates,
        id: "",
        labels: [],
        parentIds: [],
        postalCodes: [],
        type: FormLocationType.COMMUTE,
        commuteDuration: defaultTravelTime,
        commuteMode: defaultTravelMode
      }
    ]);
    setIsInit(true);
  }, []);
  return isInit;
};

export { useInitialCommuteLocation, useIsochroneMap };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LOGDY5AH.js.map